import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function getLicenseStatus(){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_LICENSESTATUS_REQUESTED", "GET_LICENSESTATUS_SUCCESS", "GET_LICENSESTATUS_FAILED"],
        method: "POST",
        path: "license_status/",
        body: data
    });
}


// WEBPACK FOOTER //
// ./src/actions/actionFooter.js